import React, { useEffect, useRef, useState } from 'react'
import MaterialTable from '@material-table/core'
import { Button, Card, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { Colors } from '@auteco/theme'
import {
  assignMaterialsToGroup,
  getOneGroup,
  importGroupMaterials,
} from '@auteco/services/snopServices'
import { Alert } from '@auteco/components/snopComponents/Alert'
import AddIcon from '@material-ui/icons/Add'
import VisibilityIcon from '@material-ui/icons/Visibility'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { AiFillEdit } from 'react-icons/ai'
import { initialAlert } from '@auteco/constants'
import Snackbar from '@auteco/components/sharedComponents/Snackbar/Snackbar'
import { DialogCreateGroup } from '../DialogCreateGroup'
import { DialogConsultGroup } from '../DialogConsultGroup'
import { DialogDelete } from '../DialogDelete'
import useStyles from './styles'

const initialDialog = {
  open: false,
  onClose: () => {},
  type: '',
}

const CreateGroupTable = ({groups, getGroups,loading, setLoading, materials, getUnassignedMaterials }) => {
  const [dialogInfo, setDialogInfo] = useState(initialDialog)
  const [alertInfo, setAlertInfo] = useState(initialAlert)
  const [availableMaterials, setAvailableMaterials] = useState(materials || [])
  const [groupId, setGroupdId] = useState('')
  const [snackbarInfo, setSnackbarInfo] = useState({
    open: false,
    message: '',
    severity: 'success',
  })
  const fileInputRef = useRef(null)

  const classes = useStyles()
  const checkboxRef = useRef([])


 

  const getAssignedMaterials = async ({ id }) => {
    setLoading(true)
    setGroupdId(id)
    if (id !== '') {
      const { materiales } = await getOneGroup({ id })
      if (materiales) {
        const available = materials.filter(
          (material1) =>
            !materiales.some(
              (material2) => material2.material === material1.Material,
            ),
        )
        setAvailableMaterials(available)
      }
    } else {
      setAvailableMaterials(materials)
    }
    setLoading(false)
  }
  const columns = [
    {
      title: 'Material',
      field: 'id',
    },
    {
      title: 'Descripción',
      field: 'texto',
    },
    {
      title: 'Grupo',
      field: 'gnombre',
    },
    {
      title: 'Obligatorio',
      field: 'obligatorio',
    },
    {
      title: 'Vertical',
      field: 'vertical',
    },
    {
      title: 'Categoria',
      field: 'categoria',
    },
    {
      title: 'Marca',
      field: 'marca',
    },
    {
      title: 'Familia',
      field: 'familia',
    },
  ]

  const verifyValue = ({ value, param }) => (value === null ? '' : value[param])

  const openDialog = ({ type }) => {
    setDialogInfo({
      open: true,
      onClose: () => setDialogInfo(initialDialog),
      type,
    })
  }

  const onCloseAlert = () => {
    setAlertInfo(initialAlert)
  }

  const handleFileUpload = async (event) => {
    const file = event.target.files[0]
    if (!file) return

    const result = await importGroupMaterials(file)
    
    if (result.success) {
      setSnackbarInfo({
        open: true,
        message: 'Archivo importado exitosamente',
        severity: 'success',
      })
      // Refresh the groups and materials after successful import
      getGroups()
      getUnassignedMaterials()
    } else {
      setSnackbarInfo({
        open: true,
        message: result.error || 'Error al importar el archivo',
        severity: 'danger',
      })
    }
    
    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleImportClick = () => {
    fileInputRef.current?.click()
  }

  const onCloseSnackbar = () => {
    setSnackbarInfo({ ...snackbarInfo, open: false })
  }

  const onAssignMaterials = async () => {
    setLoading(true)
    if (checkboxRef.current && checkboxRef.current.length > 0) {
      const codes = checkboxRef.current.map((material) => ({
        material: material.id,
      }))
      const body = {
        grupo_id: groupId,
        material: codes,
      }
      const { success } = await assignMaterialsToGroup({ params: body })
      if (success > 0) {
        getAssignedMaterials({ id: groupId })
        getUnassignedMaterials()
      }else{
        setAlertInfo({
          title: 'Error',
          content: 'Error al asignar los materiales al grupo, recuerda que el límite de asignación es 10.000 materiales',
          textBtn1: 'Cerrar',
          textBtn2: '',
          open: true,
          onClose: onCloseAlert,
          funcBtn: onCloseAlert,
        })
      }
    } else {
      setAlertInfo({
        title: 'Error',
        content: 'Selecciona al menos un material para asignar al grupo',
        textBtn1: 'Cerrar',
        textBtn2: '',
        open: true,
        onClose: onCloseAlert,
        funcBtn: onCloseAlert,
      })
    }
    setLoading(false)
  }


  useEffect(() => {
    setAvailableMaterials(materials || [])
  }, [materials])
  return (
    <>
      {dialogInfo.type === 'create' && (
        <DialogCreateGroup
          open={dialogInfo.open}
          onClose={dialogInfo.onClose}
          getGroups={getGroups}
        />
      )}
      {dialogInfo.type === 'consult' && (
        <DialogConsultGroup
          open={dialogInfo.open}
          onClose={dialogInfo.onClose}
          groups={groups || []}
        />
      )}
      {dialogInfo.type === 'delete' && (
        <DialogDelete
          options={groups || []}
          type="grupo"
          functionSuccess={getGroups}
          open={dialogInfo.open}
          onClose={dialogInfo.onClose}
        />
      )}
      <Alert
        title={alertInfo.title}
        content={alertInfo.content}
        textBtn1={alertInfo.textBtn1}
        textBtn2={alertInfo.textBtn2}
        funcBtn={alertInfo.funcBtn}
        open={alertInfo.open}
        onClose={onCloseAlert}
      />
        <>
          {availableMaterials && availableMaterials.length > 0 && (
            <Card className={classes.container}>
              <div className={classes.header}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  value={groups && groups.find((option) => option.id === groupId) || null}
                  options={groups || []}
                  getOptionLabel={(option) => option.nombre}
                  onChange={(e, newValue) =>
                    setGroupdId(verifyValue({ value: newValue, param: 'id' }))
                  }
                  className={classes.groupFilter}
                  renderInput={(params) => (
                    <TextField {...params} label="Grupos" variant="outlined" />
                  )}
                />
                <Button
                  variant="contained"
                  className={classes.assignBtn}
                  onClick={onAssignMaterials}
                  disabled={groupId === '' || loading}
                  loading={loading}
                >
                  Asignar
                </Button>
              </div>
              <MaterialTable
                style={{
                  color: '#5A5A5A',
                  fontWeight: 600,
                  '&.css-wk9895-MuiToolbar-root': {
                    background: 'red',
                  },
                }}
                isLoading={loading}
                title=""
                columns={columns}
                data={availableMaterials}
                onSelectionChange={(items) => {
                  checkboxRef.current = items
                }}
                options={{
                  selection: true,
                  pageSize: 20,
                  pageSizeOptions: [20, 50, 100],
                  headerStyle: {
                    backgroundColor: Colors.BLUE,
                    color: '#f1f1f1',
                    fontSize: '14px',
                    fontWeight: 700,
                    position: 'sticky', zIndex: '10'
                  },
                  maxBodyHeight: '500px',
                  rowStyle: (rowData, index) => ({
                    backgroundColor: index % 2 === 0 ? 'white' : Colors.GRAY_BACKGROUND,
                    padding: '5px',
                    fontSize: '12px',
                  }),
                  selectionProps: (rowData) => ({
                    color:
                      rowData?.tableData?.estado == 1 ? 'primary' : 'secondary',
                  }),
                  actionsColumnIndex: -1,
                }}
              />
            </Card>
          )}
          <Card className={classes.container}>
            <Button
              variant="contained"
              className={classes.actionBtn}
              endIcon={<AddIcon />}
              onClick={() => openDialog({ type: 'create' })}
            >
              Crear grupo
            </Button>
            <Button
              variant="contained"
              className={classes.actionBtn}
              endIcon={<VisibilityIcon />}
              onClick={() => openDialog({ type: 'consult' })}
            >
              Consultar grupo
            </Button>
            <Button
              variant="contained"
              className={classes.actionBtn}
              endIcon={<AiFillEdit />}
              onClick={() => openDialog({ type: 'delete' })}
            >
              Editar o eliminar grupos
            </Button>
            <Button
              variant="contained"
              className={classes.actionBtn}
              endIcon={<CloudUploadIcon />}
              onClick={handleImportClick}
            >
              Importar agrupación
            </Button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileUpload}
              accept=".csv,.xlsx,.xls"
              style={{ display: 'none' }}
            />
          </Card>
        </>
      <Snackbar
        place="tr"
        color={snackbarInfo.severity}
        message={snackbarInfo.message}
        open={snackbarInfo.open}
        closeNotification={onCloseSnackbar}
      />
    </>
  )
}

export { CreateGroupTable }
